export class PaymentOptionFilter {
    public IncludeInactive?: boolean;
}

export default PaymentOptionFilter;